import { Collapse, IconButton, Stack, Typography } from '@mui/material';
import { FC, PropsWithChildren, useState } from 'react';

import { DropdownIcon } from '../assets/icons';

export const ExpandableGroup: FC<PropsWithChildren<{ isExpanded: boolean; title: string }>> = ({
  isExpanded: isInitiallyExpanded,
  title,
  children,
}) => {
  const [isExpanded, setExpanded] = useState(isInitiallyExpanded);
  return (
    <Stack>
      <Stack
        flexDirection="row"
        justifyContent="space-between"
        onClick={() => setExpanded(!isExpanded)}
        sx={{
          cursor: 'pointer',
          ':hover': {
            h4: { color: 'primary.main' },
            '.expandIcon': { path: { color: 'primary.main' } },
          },
        }}
      >
        <Typography variant="h4" color={isExpanded ? 'primary.main' : undefined}>
          {title}
        </Typography>
        <IconButton inverse={!isExpanded} onClick={() => setExpanded(!isExpanded)}>
          <DropdownIcon
            className="expandIcon"
            style={{
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </IconButton>
      </Stack>
      <Collapse in={isExpanded}>
        <Stack pt={2}>{children}</Stack>
      </Collapse>
    </Stack>
  );
};
